import utils from "../helpers/utils";
import _get from "lodash/get";
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SET_MODAL_SIZE_SPEC = 'SET_MODAL_SIZE_SPEC';


export function showModalCredit(modalName, data){
  return (dispatch) => {
    let option;
    let filesCnt = _get(data, 'filesCnt', 0);
    let sectionName = _get(data, 'sectionName.sectionName', '');

    switch (modalName) {
      case "CREDIT_HISTORY_MODAL":
        option = {
          value: 1,
          label: 'Full History',
          action: 'View',
          category: 'Credit'
        };
        break;

      case "CREDIT_INQUIRIES_MODAL":
        option = {
          value: 1,
          label: 'Inquiries',
          action: 'View',
          category: 'Credit'
        };
        break;

      case "CREDIT_REPORT_DOWNLOAD_MODAL":
        option = {
          value: 1,
          label: filesCnt.toString(),
          action: 'Download',
          category: 'Credit'
        };
        break;

      case "CREDIT_REPORT_INACCURACY_MODAL":
        option = {
          value: 1,
          label: sectionName.toString(),
          action: 'Inaccuracy',
          category: 'Credit'
        };
        break;
      default:
        option = {
          value: '',
          label: '',
          action: '',
          category: ''
        };
        break;
    }

    utils.trackEvent(option);

    dispatch({
      type: 'SHOW_MODAL',
      modalType: modalName,
      modalProps: {data}
    });


  }
}

export function hideModal() {
  return {
    type: HIDE_MODAL,
  };
}

export function showModal() {
  return {
    type: SHOW_MODAL,
  };
}

export function setModalSizeSpec(modalSizeSpec) {
  return {
    type: SET_MODAL_SIZE_SPEC,
    modalSizeSpec
  };
}


// WEBPACK FOOTER //
// ./src/actions/modal.js